import { useNavigateToAgentsEditor } from '@/hooks/navigation/useNavigateToAgentsEditor';
import CreateAgent from '@/images/agents/CreateAgent.png';
import theme from '@/theme';
import styled from '@emotion/styled';
import Button from '../Buttons/Button';

const BannerContainer = styled.div`
    gap: 1rem;
    display: flex;
    overflow: hidden;
    background-color: ${theme.colors.secondary.main};
    border-radius: 0.75rem;
    box-shadow:
        1.1px 2.7px 3.8px -1.2px rgba(187, 187, 187, 0.26),
        0.5px 1.3px 1.8px -0.6px rgba(187, 187, 187, 0.18),
        0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.11);
    width: 100%;
`;

const Content = styled.div`
    flex: 1;
    padding: 20px 32px;
`;

const Title = styled.span`
    font-size: clamp(1rem, 1.5vw, 2rem);
    font-weight: 700;
    display: flex;
    color: ${theme.colors.secondary[100]};
    margin-bottom: 1rem;
`;

const Subtitle = styled.span`
    font-size: 1.5rem;
    font-weight: 400;
    color: ${theme.colors.secondary[100]};
    display: flex;
    margin-bottom: 1.2rem;
`;

const Image = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;

    img {
        display: block;
        width: 70%;
        height: 100%;
        object-fit: cover;
    }
`;

export const CreateAgentBanner = () => {
    const { navigateToAgentEditor } = useNavigateToAgentsEditor();

    const handleClick = () => {
        navigateToAgentEditor({ mixPanelFrom: 'create-agent-banner' });
    };

    return (
        <BannerContainer>
            <Content>
                <Title>Create your first agent</Title>
                <Subtitle>
                    Craft a unique AI agent of your own by uploading your data and effortlessly customizing its appearance and personality
                </Subtitle>
                <Button aria-valuetext="Create your first agent" color="primary" onClick={handleClick}>
                    Create your first agent
                </Button>
            </Content>
            <Image>
                <img src={CreateAgent} alt="Banner Image" />
            </Image>
        </BannerContainer>
    );
};
